import axios from 'axios';
const url = "https://api.tunnelgraphic.com"
const ResGet = (adress)=>{
  return axios.get(`${url}/${adress}`,
  {
    headers: {
    'Content-Type': 'application/json'
  }
  }
  )
  .then(function (response) {
    const allData = response.data
    return allData
  })
  .catch(function (error) {
    return false
  });
}

const ResPost = (adress,data)=>{
  return axios.post(`${url}/${adress}`,JSON.stringify(data),
  {
    headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  }
  }, {
    // Separate configuration
    withCredentials: true
  }
  )
  .then(function (response) {
    const allData = response.data
    return allData
  })
  .catch(function (error) {
    return false
  });
}
export {ResGet,ResPost,url}; 